import Age from './Age';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';

import { buildAgeOptions } from './helpers';
import { trackAgeChange } from '../../../../../analytics/category/product';

const enhance = compose(
  withProps(props => ({
    options: buildAgeOptions(props.range, props.noAge),
  })),
  withHandlers({
    onHandleChange: props => event => {
      trackAgeChange(event.target.value);
      props.onHandleChange(event);
    }
  })
);

export default enhance(Age);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Adventurer/Age/index.js